import { TLang } from '.';

export enum ELanguageQueryString {
  AR = 'ar',
  EN = 'en',
  ES = 'es',
  ID = 'id',
  JA = 'ja',
  JP = 'jp',
  KO = 'ko',
  MS = 'ms',
  PT = 'pt',
  TH = 'th',
  VI = 'vi',
  VN = 'vn',
  ZH = 'zh',
  ZH_HANS = 'zh-hans',
  ZH_HANT = 'zh-hant'
}

export const mapLangQueryStringToTLang: Record<ELanguageQueryString, TLang> = {
  [ELanguageQueryString.AR]: 'ar_AE',
  [ELanguageQueryString.EN]: 'en_GB',
  [ELanguageQueryString.ES]: 'es_ES',
  [ELanguageQueryString.ID]: 'id_ID',
  [ELanguageQueryString.JA]: 'ja_JP',
  [ELanguageQueryString.JP]: 'ja_JP',
  [ELanguageQueryString.KO]: 'ko_KR',
  [ELanguageQueryString.MS]: 'ms_MY',
  [ELanguageQueryString.PT]: 'pt_BR',
  [ELanguageQueryString.TH]: 'th_TH',
  [ELanguageQueryString.VI]: 'vi_VN',
  [ELanguageQueryString.VN]: 'vi_VN',
  [ELanguageQueryString.ZH]: 'zh_CN',
  [ELanguageQueryString.ZH_HANS]: 'zh_CN',
  [ELanguageQueryString.ZH_HANT]: 'zh_TW'
};

export const mapTLangToLangQuery: Record<TLang, ELanguageQueryString> = {
  ar_AE: ELanguageQueryString.AR,
  en_GB: ELanguageQueryString.EN,
  es_ES: ELanguageQueryString.ES,
  id_ID: ELanguageQueryString.ID,
  ja_JP: ELanguageQueryString.JP, // ELanguageQueryString.JA
  ko_KR: ELanguageQueryString.KO,
  ms_MY: ELanguageQueryString.MS,
  pt_BR: ELanguageQueryString.PT,
  th_TH: ELanguageQueryString.TH,
  vi_VN: ELanguageQueryString.VI, // ELanguageQueryString.VN
  zh_CN: ELanguageQueryString.ZH_HANS, // ELanguageQueryString.ZH
  zh_TW: ELanguageQueryString.ZH_HANT
};
